module.exports = __webpack_public_path__ + "img/2.4db2d3e2.jpg";